import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArgonButton from "components/ArgonButton";
import { markAdminUnreadSeen } from "services/adminUnreadService";

function AdminSeenViewButton({ module, item, onView, onSeen, tooltip, sx, ...rest }) {
  const handleClick = async (event) => {
    if (onView) {
      onView(item, event);
    }

    if (!item?._id || !item.adminUnread) return;

    try {
      const response = await markAdminUnreadSeen(module, item._id);
      if (onSeen) {
        onSeen(response, item);
      }
    } catch (error) {
      console.error("Error marking admin unread item as seen:", error);
    }
  };

  return (
    <Tooltip title={tooltip} placement="top">
      <ArgonButton
        variant="text"
        size="large"
        onClick={handleClick}
        sx={{
          minWidth: "32px",
          p: 0,
          borderRadius: "50%",
          backgroundColor: item?.adminUnread ? "rgba(45, 206, 137, 0.1)" : "transparent",
          "&:hover": {
            backgroundColor: item?.adminUnread
              ? "rgba(245, 54, 92, 0.18)"
              : "rgba(94, 114, 228, 0.1)",
          },
          ...sx,
        }}
        {...rest}
      >
        <VisibilityIcon color={item?.adminUnread ? "error" : "primary"} />
      </ArgonButton>
    </Tooltip>
  );
}

AdminSeenViewButton.defaultProps = {
  item: null,
  onView: undefined,
  onSeen: undefined,
  tooltip: "View details",
  sx: {},
};

AdminSeenViewButton.propTypes = {
  module: PropTypes.string.isRequired,
  item: PropTypes.shape({
    _id: PropTypes.string,
    adminUnread: PropTypes.bool,
  }),
  onView: PropTypes.func,
  onSeen: PropTypes.func,
  tooltip: PropTypes.string,
  sx: PropTypes.object,
};

export default AdminSeenViewButton;
